import { t } from 'i18next';

export const RULES = {
  REQUIRED: { required: true, message: t('DefaultTranslations:REQUIRED_FIELD') },
  URL: { type: 'url', message: t('DefaultTranslations:WRONG_FORMAT_URL') }
};
